module.exports = __webpack_public_path__ + "img/mz.fba88bfe.svg";